export default __webpack_public_path__ + "static/media/sasuke.4abbc2d3.png";